import { module } from "angular";
import { UserInfoTableComponent } from "./UserInfoTableComponent";

module("mmGui").component("mmUserInfoTable", new UserInfoTableComponent());
